// extracted by mini-css-extract-plugin
export default {"error-container":"ErrorBoundary_error-container__A961p","error-text-container":"ErrorBoundary_error-text-container__6Cmk1"};